module.exports = __webpack_public_path__ + "static/img/menu13.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu13.png
// module id = 554
// module chunks = 0